import { useMemo } from "react";

const BASE_SURVEY_URL = "https://survey.haevn.co/";

export function useSurveyUrl() {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.toString()) {
      return `${BASE_SURVEY_URL}?${params.toString()}`;
    }
    return BASE_SURVEY_URL;
  }, []);
}

export function getSurveyUrl() {
  const params = new URLSearchParams(window.location.search);
  if (params.toString()) {
    return `${BASE_SURVEY_URL}?${params.toString()}`;
  }
  return BASE_SURVEY_URL;
}
